module.exports = __webpack_public_path__ + "static/media/46_A.2837e45d.png";